export default __webpack_public_path__ + "static/media/the-villa5.3ed7db1a.webp";